import React, { useRef, useEffect ,useState} from "react";
import { useNavigate } from "react-router-dom";
import "./CommercialRooftop.css";
import ecoBg from "../../assets/eco-bg.png";
import cirHeroImg from "../../assets/CIRsection1.png";
import cirSPVImg from "../../assets/commercial-rooftopsection-2.png";
import IconManufacturers from "../../assets/Manufacturers.png";
import IconPharma from "../../assets/Pharma.png";
import IconFMCG from "../../assets/FMCG.png";
import IconITPark from "../../assets/IT.png";
import IconDataCenter from "../../assets/Data.png";
import IconTexiles from "../../assets/textiles.png";
import IconWarehouse from "../../assets/Warehouse.png";
import IconAutomotive from "../../assets/Automotive.png";
import IconSteel from "../../assets/Steel.png";
import IconChemical from "../../assets/chemical.png";
import cirArch1 from "../../assets/CIRsection3b-1.png";
import cirArch2 from "../../assets/CIRsection3b-2.png";
import cirArch3 from "../../assets/CIRsection3b-3.png";
import cirArch4 from "../../assets/c&isolutions-4.png";
import cirArch5 from "../../assets/c&isolutions-5.png";
import cirBenefitsImg from "../../assets/CIRsection3c.png";
import cirBenefit1 from "../../assets/c&ibenefits-1.png";
import cirBenefit2 from "../../assets/c&ibenefits-2.png";
import cirBenefit3 from "../../assets/c&ibenefits-3.png";
import cirBenefit4 from "../../assets/c&ibenefits-4.png";
import cirBenefit5 from "../../assets/c&ibenefits-5.png";
import trueRenewablesLogo from "../../assets/hiw_logo.svg";
import finalStep1 from "../../assets/finalstep1.png";
import finalStep2 from "../../assets/finalstep2.png";
import finalStep3 from "../../assets/finalstep3.png";
import cirWhyImg from "../../assets/commercial-whychoose.png";
import cirProj1 from "../../assets/CIRsection6-1.png";
import cirProj2 from "../../assets/CIRsection6-2.png";
// import Testi1 from "../../assets/testi1.png";
// import Testi2 from "../../assets/testi2.png";
// import Testi3 from "../../assets/testi3.png";
import crs1step1 from "../../assets/CR-s1-step1.png";
import crs1step2 from "../../assets/CR-s1-step2.png";
import crs1step3 from "../../assets/CR-s1-step3.png";
import crs1step4 from "../../assets/CR-s1-step4.png";
import crs1step5 from "../../assets/CR-s1-step5.png";
import crs1step6 from "../../assets/CR-s1-step6.png";
import crs1step7 from "../../assets/CR-s1-step7.png";
import crs2step1 from "../../assets/CR-s2-step1.png";
import crs2step2 from "../../assets/CR-s2-step2.png";
import crs2step3 from "../../assets/CR-s2-step3.png";
import crs2step4 from "../../assets/CR-s2-step4.png";
import crs2step5 from "../../assets/CR-s2-step5.png";
import crs2step6 from "../../assets/CR-s2-step6.png";
import crs2step7 from "../../assets/CR-s2-step7.png";
import crs3step1 from "../../assets/CR-s3-step1.png";
import crs3step2 from "../../assets/CR-s3-step2.png";
import crs3step3 from "../../assets/CR-s3-step3.png";
import crs3step4 from "../../assets/CR-s3-step4.png";
import crs3step5 from "../../assets/CR-s3-step5.png";
import crs3step6 from "../../assets/CR-s3-step6.png";
import crs3step7 from "../../assets/CR-s3-step7.png";
import crs4step1 from "../../assets/CR-s4-step1.png";
import crs4step2 from "../../assets/CR-s4-step2.png";
import crs4step3 from "../../assets/CR-s4-step3.png";
import crs4step4 from "../../assets/CR-s4-step4.png";
import crs4step5 from "../../assets/CR-s4-step5.png";
import crs4step6 from "../../assets/CR-s4-step6.png";
import crs4step7 from "../../assets/CR-s4-step7.png";
import crs5step1 from "../../assets/CR-s5-step1.png";
import crs5step2 from "../../assets/CR-s5-step2.png";
import crs5step3 from "../../assets/CR-s5-step3.png";
import crs5step4 from "../../assets/CR-s5-step4.png";
import crs5step5 from "../../assets/CR-s5-step5.png";
import crs5step6 from "../../assets/CR-s5-step6.png";
import crs6step1 from "../../assets/CR-s6-step1.png";
import crs6step2 from "../../assets/CR-s6-step2.png";
import crs6step3 from "../../assets/CR-s6-step3.png";
import crs6step4 from "../../assets/CR-s6-step4.png";
import crs6step5 from "../../assets/CR-s6-step5.png";
import crs6step6 from "../../assets/CR-s6-step6.png";
import crs6step7 from "../../assets/CR-s6-step7.png";
import crs7step1 from "../../assets/CR-s7-step1.png";
import crs7step2 from "../../assets/CR-s7-step2.png";
import crs7step3 from "../../assets/CR-s7-step3.png";
import crs7step4 from "../../assets/CR-s7-step4.png";
import crs7step5 from "../../assets/CR-s7-step5.png";
import crs7step6 from "../../assets/CR-s7-step6.png";
import crs7step7 from "../../assets/CR-s7-step7.png";
import crs7step8 from "../../assets/CR-s7-step8.png";
import crs8step1 from "../../assets/CR-s8-step1.png";
import crs8step2 from "../../assets/CR-s8-step2.png";
import crs8step3 from "../../assets/CR-s8-step3.png";
import crs8step4 from "../../assets/CR-s8-step4.png";
import crs8step5 from "../../assets/CR-s8-step5.png";
import crs8step6 from "../../assets/CR-s8-step6.png";
import crs9step1 from "../../assets/CR-s9-step1.png";
import crs9step2 from "../../assets/CR-s9-step2.png";
import crs9step3 from "../../assets/CR-s9-step3.png";
import crs9step4 from "../../assets/CR-s9-step4.png";
import crs9step5 from "../../assets/CR-s9-step5.png";
import crs9step6 from "../../assets/CR-s9-step6.png";
import crs9step7 from "../../assets/CR-s9-step7.png";
import crs10step1 from "../../assets/CR-s10-step1.png";
import crs10step2 from "../../assets/CR-s10-step2.png";
import crs10step3 from "../../assets/CR-s10-step3.png";
import crs10step4 from "../../assets/CR-s10-step4.png";
import crs10step5 from "../../assets/CR-s10-step5.png";
import crs10step6 from "../../assets/CR-s10-step6.png";
import crs10step7 from "../../assets/CR-s10-step7.png";
import crs10step8 from "../../assets/CR-s10-step8.png";
import crs11step1 from "../../assets/CR-s11-step1.png";
import crs11step2 from "../../assets/CR-s11-step2.png";
import crs11step3 from "../../assets/CR-s11-step3.png";
import crs11step4 from "../../assets/CR-s11-step4.png";
import crs11step5 from "../../assets/CR-s11-step5.png";
import crs11step6 from "../../assets/CR-s11-step6.png";
import crs11step7 from "../../assets/CR-s11-step7.png";
import crs12step1 from "../../assets/CR-s12-step1.png";
import crs12step2 from "../../assets/CR-s12-step2.png";
import crs12step3 from "../../assets/CR-s12-step3.png";
import crs12step4 from "../../assets/CR-s12-step4.png";
import crs12step5 from "../../assets/CR-s12-step5.png";
import crs12step6 from "../../assets/CR-s12-step6.png";
import crs12step7 from "../../assets/CR-s12-step7.png";

const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };

    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);
  return ref;
};

/* ================================================
   SECTION 1 — HERO
   ================================================ */
const CommercialRooftopHero = () => {
  const navigate = useNavigate();
  return (
    <section className="cir-hero" style={{ "--eco-bg": `url(${ecoBg})` }}>
      {/* ── Top text row ── */}
      <div className="cir-hero-top">
        <h1 className="cir-hero-title">
          Reduce Energy Cost. Improve Profitability. Strengthen Sustainability.
        </h1>
        <p className="cir-hero-desc">
          Reduce energy costs by 30–60% with end-to-end C&I rooftop
          solar—engineered for performance and long-term stability.
        </p>
      </div>

      {/* ── CTA button (mobile only) ── */}
      <div className="cir-hero-cta">
        <button onClick={() => navigate("/contact")}>Book A Free Call</button>
      </div>

      {/* ── Bottom full-width image ── */}
      <div className="cir-hero-img-wrap">
        <img
          src={cirHeroImg}
          alt="Commercial & Industrial Rooftop Solar"
          className="cir-hero-img"
        />
      </div>
    </section>
  );
};

/* ================================================
   SECTION 2 — C&I ROOFTOP PROVIDES
   ================================================ */
const CommercialRooftopSPV = () => {
  const checkItems = [
    "Significant reduction in electricity bills",
    "Fast payback period (3–4 years)",
    "Zero production interruptions",
    "Long-term tariff stability (25 years)",
    "High system performance and reliability",
    "Strong contribution to ESG & sustainability goals",
  ];

  return (
    <section className="cir-spv">
      <div className="cir-spv-inner">
        {/* ── Left text card ── */}
        <div className="cir-spv-card">
          <h3 className="cir-spv-card-heading">C&I rooftop solar provides:</h3>

          <ul className="cir-spv-checklist">
            {checkItems.map((item, i) => (
              <li key={i} className="cir-spv-check-item">
                <svg
                  className="cir-spv-check-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 12.5L9.5 18L20 7"
                    stroke="#C04820"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {item}
              </li>
            ))}
          </ul>

          <p className="cir-spv-bottom-text">
            Industries get complete control over power cost while improving
            operational efficiency.
          </p>
        </div>

        {/* ── Right image ── */}
        <div className="cir-spv-img-wrap">
          <img
            src={cirSPVImg}
            alt="C&I Rooftop Solar Installation"
            className="cir-spv-img"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 3 — WHO IT'S FOR
   ================================================ */
const CIR_WHO_ITEMS_TOP = [
  { label: "Manufacturers", icon: IconManufacturers },
  { label: "Pharma", icon: IconPharma },
  { label: "FMCG", icon: IconFMCG },
  { label: "IT Parks", icon: IconITPark },
  { label: "Data Centers", icon: IconDataCenter },
];

const CIR_WHO_ITEMS_BOTTOM = [
  { label: "Textiles", icon: IconTexiles },
  { label: "Warehousing & Logistics", icon: IconWarehouse },
  { label: "Automotive", icon: IconAutomotive },
  { label: "Steel & Fabrication", icon: IconSteel },
  { label: "Chemical", icon: IconChemical },
];

const CommercialRooftopWhoItsFor = () => {
  const topTicker = [
    ...CIR_WHO_ITEMS_TOP,
    ...CIR_WHO_ITEMS_TOP,
    ...CIR_WHO_ITEMS_TOP,
    ...CIR_WHO_ITEMS_TOP,
  ];
  const bottomTicker = [
    ...CIR_WHO_ITEMS_BOTTOM,
    ...CIR_WHO_ITEMS_BOTTOM,
    ...CIR_WHO_ITEMS_BOTTOM,
    ...CIR_WHO_ITEMS_BOTTOM,
  ];

  return (
    <section className="cir-who-section">
      <div className="cir-who-header">
        <p className="cir-who-tag">
          <span className="cir-who-dot" />
          WHO IT'S FOR
        </p>
        <h2 className="cir-who-title">
          Built for Commercial &<br className="cir-who-title-br" /> Industrial Leaders
        </h2>
        <p className="cir-who-subtitle">
          Scalable C&I solar solutions delivering measurable savings and
          lifetime performance.
        </p>
      </div>

      <div className="cir-who-ticker">
        <div className="cir-who-track">
          <div className="cir-who-row cir-who-row-top">
            {topTicker.map((item, i) => (
              <div className="cir-who-card" key={`top-${i}`}>
                <img
                  src={item.icon}
                  alt={item.label}
                  className="cir-who-card-icon"
                  loading="lazy"
                />
                <p className="cir-who-card-label">{item.label}</p>
              </div>
            ))}
          </div>

          <div className="cir-who-row cir-who-row-bottom">
            {bottomTicker.map((item, i) => (
              <div className="cir-who-card" key={`bottom-${i}`}>
                <img
                  src={item.icon}
                  alt={item.label}
                  className="cir-who-card-icon"
                  loading="lazy"
                />
                <p className="cir-who-card-label">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 3B — C&I SOLUTIONS
   ================================================ */
const CommercialRooftopSolutions = () => {
  const cards = [
    {
      img: cirArch1,
      title: "On-Grid Rooftop Systems",
      desc: "Low cost, high efficiency, with net metering or gross metering.",
    },
    {
      img: cirArch2,
      title: "Hybrid Systems (Solar + Battery)",
      desc: "Ensures uninterrupted operations for critical loads.",
    },
    {
      img: cirArch3,
      title: "Industrial Carport Solar Structures",
      desc: "Utilize parking spaces for power generation.",
    },
    {
      img: cirArch4,
      title: "Elevated Rooftop Structures",
      desc: "Ideal for factories requiring free ground movement.",
    },
    {
      img: cirArch5,
      title: "High-Wattage Mono PERC / TOPCon / Bifacial Systems",
      desc: "Maximum output, better generation, improved lifetime yield.",
    },
  ];

  return (
    <section className="cir-arch">
      <div className="cir-arch-header">
        <p className="cir-arch-tag">
          <span className="cir-arch-dot" />
          C&I SOLUTIONS
        </p>
        <h2 className="cir-arch-title">
          Engineered Solar Systems For Every Need
        </h2>
        <p className="cir-arch-desc">
          Flexible system configurations designed for performance, reliability,
          and maximum space utilization.
        </p>
      </div>

      <div className="cir-arch-scroll">
        {cards.map((card, i) => (
          <div className="cir-arch-card" key={i}>
            <div className="cir-arch-card-img-wrap">
              <img
                src={card.img}
                alt={card.title}
                className="cir-arch-card-img"
                loading="lazy"
              />
            </div>
            <div className="cir-arch-card-text">
              <h3 className="cir-arch-card-title">{card.title}</h3>
              <p className="cir-arch-card-desc">{card.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
/* ================================================
   SECTION 3C — FINANCIAL BENEFITS
   ================================================ */
const cirBenefitItems = [
  {
    title: "Lower Electricity Tariff",
    desc: "Reduces per-unit cost sharply.",
    image: cirBenefit1,
  },
  {
    title: "Asset with 25-Year Lifespan",
    desc: "Choose between owning the asset or paying only for power.",
    image: cirBenefit2,
  },
  {
    title: "Attractive ROI",
    desc: "Additional financial advantages for industrial clients.",
    image: cirBenefit3,
  },
  {
    title: "Accelerated Depreciation Benefits",
    desc: "ROI ranges from 18–25% depending on structure and policy.",
    image: cirBenefit4,
  },
  {
    title: "CAPEX + OPEX Options Available",
    desc: "Long-term savings with minimal maintenance.",
    image: cirBenefit5,
  },
];

const CommercialRooftopBenefits = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const outerRef = useRef(null);
  const activeIndexRef = useRef(0);

  /* ── Pin the panel while scrolling through the outer (tall) wrapper,
     driving activeIndex from scroll progress. ── */
  useEffect(() => {
    let raf;

    const update = () => {
      const el = outerRef.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        const totalScroll = el.offsetHeight - window.innerHeight;
        const scrolled = -rect.top;
        const p =
          totalScroll > 0
            ? Math.max(0, Math.min(scrolled / totalScroll, 1))
            : 0;

        const idx = Math.min(
          cirBenefitItems.length - 1,
          Math.floor(p * cirBenefitItems.length)
        );

        if (idx !== activeIndexRef.current) {
          activeIndexRef.current = idx;
          setActiveIndex(idx);
        }
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const timer = setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className="cir-benefits-outer"
      ref={outerRef}
      style={{ height: `${cirBenefitItems.length * 110}vh` }}
    >
      <section className="cir-benefits-sticky">
        <div className="cir-benefits">
          <div className="cir-benefits-header">
            <p className="cir-benefits-tag">
              <span className="cir-benefits-dot" />
              FINANCIAL BENEFITS
            </p>
            <h2 className="cir-benefits-title">
              Maximized Returns. Structured For Stability.
            </h2>
          </div>

          <div className="cir-benefits-body">
            <div className="cir-benefits-list">
              {cirBenefitItems.map((item, i) => (
                <div key={i}>
                  <div
                    className={`cir-benefit-item ${
                      i === activeIndex ? "cir-benefit-item--active" : ""
                    }`}
                    onClick={() => setActiveIndex(i)}
                    onMouseEnter={() => setActiveIndex(i)}
                  >
                    {/* Orange bar — only for active */}
                    {i === activeIndex && <span className="cir-benefit-bar" />}

                    <div className="cir-benefit-text">
                      <p className="cir-benefit-title">{item.title}</p>

                      {/* Desc — only for active, animates in */}
                      {i === activeIndex && (
                        <p className="cir-benefit-desc">{item.desc}</p>
                      )}
                    </div>
                  </div>

                  {/* Mobile-only inline image — appears below the active item */}
                  <div className="cir-benefit-mobile-img-wrap">
                    <div className="cir-benefit-mobile-img-bg" />
                    <img
                      src={item.image}
                      alt={item.title}
                      className="cir-benefit-mobile-img"
                      loading="lazy"
                    />
                  </div>

                  {i < cirBenefitItems.length - 1 && (
                    <hr className="cir-benefit-divider" />
                  )}
                </div>
              ))}
            </div>

            <div className="cir-benefits-img-wrap">
              <div className="cir-benefits-img-bg" />
              <img
                src={cirBenefitItems[activeIndex].image}
                alt={cirBenefitItems[activeIndex].title}
                className="cir-benefits-img"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
/* ================================================
   SECTION 4 — HOW IT WORKS
   ================================================ */
const cirStages = [
  {
    id: 1,
    title: "Load & Feasibility",
    steps: [
      { title: "12-36 month consumption study" , image: crs1step1},
      { title: "Load curve: base load, peak load, shifting patterns" , image: crs1step2},
      { title: "Rooftop suitability for solar export vs captive consumption" , image: crs1step3},
      { title: "Rooftop area availability (shadow-free zone mapping)" , image: crs1step4},
      { title: "Option modelling: on-grid / hybrid / battery-integrated" , image: crs1step5},
      { title: "Earthing & electrical infrastructure feasibility" , image: crs1step6},
      { title: "Expected savings and ROI estimation" , image: crs1step7},
    ],
  },
  {
    id: 2,
    title: "Structural Audit",
    steps: [
      { title: "RCC / PEB / metal sheet structural load analysis" , image: crs12step1},
      { title: "Wind load modelling per IS 875 standards" , image: crs12step2},
      { title: "Corrosion risk assessment (coastal/industrial)" , image: crs12step3},
      { title: "Column-beam strength check (for warehouses and PEBs)" , image: crs12step4},
      { title: "Roof integrity, slope, drainage & walkway planning" , image: crs12step5},
      { title: "Structural stability certificate (STP) documentation" , image: crs12step6},
      { title: "Fire & safety compliance assessment" , image: crs12step7},
    ],
  },
  {
    id: 3,
    title: "System Design",
    steps: [
      { title: "Panel layout optimization (3D modelling & tilt analysis)" , image: crs3step1},
      { title: "Inverter selection: string / central / hybrid / microinverters" , image: crs3step2},
      { title: "Single-line diagrams & AC/DC schematics" , image: crs3step3},
      { title: "Cable routing, conduits & earthing design" , image: crs3step4},
      { title: "Compatibility with DG synchronization" , image: crs3step5},
      { title: "Integration with plant's existing electrical architecture" , image: crs3step6},
      { title: "Monthly generation forecast & performance simulation" , image: crs3step7 },
    ],
  },
  {
    id: 4,
    title: "Financial Planning",
    steps: [
      { title: "CAPEX / OPEX / RESCO model selection" , image: crs4step1},
      { title: "LCOE, payback, IRR & lifetime savings modelling" , image: crs4step2},
      { title: "Demand charge optimization" , image: crs4step3},
      { title: "Power factor improvement considerations" , image: crs4step4},
      { title: "Export limitation vs consumption-based system design" , image: crs4step5},
      { title: "Bank finance & EMI structuring (if applicable)" , image: crs4step6},
      { title: "Final techno-commercial proposal" , image: crs4step7 },
    ],
  },
  {
    id: 5,
    title: "Approvals & Compliance",
    steps: [
      { title: "DISCOM net-metering or gross-metering approval" , image: crs5step1},
      { title: "CEIG safety compliance (for >10 kW in some states)" , image: crs5step2},
      { title: "Fire department & factory inspectorate compliance (if applicable)" , image: crs5step3},
      { title: "Risk assessment for rooftop working" , image: crs5step4},
      { title: "Worker safety planning & scaffolding requirements" , image: crs5step5},
      { title: "Approval tracker visible inside TrueTrack™" , image: crs5step6},
    ],
  },
  {
    id: 6,
    title: "Engineering & Procurement",
    steps: [
      { title: "Final engineering drawings for customer approval" , image: crs6step1},
      { title: "Procurement of modules, inverters, structures, ACDB/DCDB" , image: crs6step2},
      { title: "Pre-dispatch QC for all components" , image: crs6step3},
      { title: "Logistics & rooftop material handling planning" , image: crs6step4},
      { title: "Temporary storage & weather protection planning" , image: crs6step5},
      { title: "Digital engineering checklists" , image: crs6step6},
      { title: "Procurement timeline tracking inside TrueTrack™" , image: crs6step7},
    ],
  },
  {
    id: 7,
    title: "EPC Execution",
    steps: [
      { title: "Daily installation progress logs (photos, videos, manpower logs)" , image: crs7step1},
      { title: "Structure mounting, panel fixing, cable laying" , image: crs7step2},
      { title: "AC/DC wiring, inverter installation, earthing & SPD integration" , image: crs7step3},
      { title: "Strict compliance with safety protocols for rooftop work" , image: crs7step4},
      { title: "Waterproofing verification & conduit sealing" , image: crs7step5},
      { title: "Automated milestone completion tracking" , image: crs7step6},
      { title: "Client dashboard for full transparency" , image: crs7step7},
      { title: "Delay prediction alerts to maintain schedule integrity" , image: crs7step8},
    ],
  },
  {
    id: 8,
    title: "Testing & Commissioning",
    steps: [
      { title: "Pre-commissioning tests (continuity, insulation, polarity, earthing resistance)" , image: crs8step1},
      { title: "Inverter grid-sync testing" , image: crs8step2},
      { title: "Load balancing and export limitation integration (if required)" , image: crs8step3},
      { title: "Net-meter installation coordination" , image: crs8step4},
      { title: "CEIG inspection & compliance certificate" , image: crs8step5},
      { title: "Handover package (drawings, test reports, warranties)" , image: crs8step6},
    ],
  },
  {
    id: 9,
    title: "Live Monitoring",
    steps: [
      { title: "SCADA/inverter remote monitoring integration" , image: crs9step1},
      { title: "Real-time generation, PR, CUF & inverter-level metrics" , image: crs9step2},
      { title: "Load vs solar consumption analytics" , image: crs9step3},
      { title: "DG synchronization logic monitoring" , image: crs9step4},
      { title: "AI-driven fault detection & predictive issue alerts" , image: crs9step5},
      { title: "Weather-based generation modelling" , image: crs9step6},
      {
        title: "Dual dashboards:", image: crs9step7,
        bullets: [
          "Engineering dashboard (SCADA, granular data)",
          "Owner dashboard (simple uptime, generation, savings)",
        ],
      },
    ],
  },
  {
    id: 10,
    title: "O&M and Asset Health",
    steps: [
      { title: "Panel cleaning schedule optimization" , image: crs10step1},
      { title: "Structural, mounting, and fastener inspections" , image: crs10step2},
      { title: "Thermography & hotspot detection" , image: crs10step3},
      { title: "Inverter servicing & AC/DC system health" , image: crs10step4},
      { title: "Safety checks: earthing, SPD, lightning protection" , image: crs10step5},
      { title: "SLA-driven corrective maintenance ticketing" , image: crs10step6},
      { title: "Monthly & annual performance reports" , image: crs10step7},
      { title: "Downtime analytics and PR improvement suggestions" , image: crs10step8},
    ],
  },
  {
    id: 11,
    title: "Billing & Savings",
    steps: [
      { title: "Monthly energy generation & savings computation" , image: crs11step1},
      { title: "Energy consumption vs solar export analytics" , image: crs11step2},
      { title: "Demand charge reduction modelling" , image: crs11step3},
      { title: "EMI tracking (if financed)" , image: crs11step4},
      { title: "Export limitation compliance & reconciliation" , image: crs11step5},
      { title: "Warranties, invoices & safety certificates stored digitally" , image: crs11step6},
      { title: "Monthly bill comparison vs DISCOM cost" , image: crs11step7},
    ],
  },
  {
    id: 12,
    title: "Lifecycle Reporting",
    steps: [
      { title: "Monthly & annual generation reports" , image: crs12step1},
      { title: "ESG-ready carbon reduction (Scope 2) documentation" , image: crs12step2},
      { title: "Portfolio dashboards for multi-site C&I clients" , image: crs12step3},
      { title: "ROI, IRR & payback updates" , image: crs12step4},
      { title: "Carbon credit eligibility evaluation (REC / I-REC / VER)" , image: crs12step5},
      { title: "Long-term performance benchmarking" , image: crs12step6},
      { title: "Upgrade recommendations (bifacial, optimizers, hybrid battery integration)" , image: crs12step7},
    ],
  },
];

const CIR_N = cirStages.length;
const CIR_RADIUS = 380;
const CIR_ANGLE_STEP = 30;
const CIR_MINOR_TICKS = 72;

const CommercialRooftopHowItWorks = () => {
  const sectionRef = useRef(null);
  const dialRef = useRef(null);
  const numRefs = useRef([]);
  const tickRefs = useRef([]);
  const itemRefs = useRef([]);
  const cardsContainerRef = useRef(null);
  const arcRef = useRef(null);
  const activeStageRef = useRef(0);
  const logoRef = useRef(null);
  const [activeIdx, setActiveIdx] = useState(0);
  const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);

  useEffect(() => {
    let raf;
    const update = () => {
      const el = sectionRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const headerEl = el.querySelector(".cir-hiw-header-wrap");
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;
      const startDelay = headerHeight + window.innerHeight * 0.2;
      const totalScroll = el.offsetHeight - window.innerHeight - startDelay;
      const scrolled = -rect.top - startDelay;
      const p = Math.max(0, Math.min(scrolled / totalScroll, 1));
      const arcFloat = p * CIR_N;
      const activeFloat = Math.min(arcFloat, CIR_N - 1);
      const activeIndex = Math.round(activeFloat);
      const currentRotation = -(activeFloat * CIR_ANGLE_STEP);
      const mobileOffset = window.innerWidth <= 1024 ? -90 : 0;

      if (dialRef.current)
        dialRef.current.style.transform = `translate(-50%, -50%) rotate(${currentRotation + mobileOffset}deg)`;
      if (logoRef.current) {
        const logoOffset = window.innerWidth <= 1024 ? 90 : 0;
        logoRef.current.style.transform = `rotate(${currentRotation + logoOffset}deg)`;
      }

      cirStages.forEach((_, i) => {
        const numEl = numRefs.current[i];
        const tickEl = tickRefs.current[i];
        const itemEl = itemRefs.current[i];
        if (!numEl || !tickEl || !itemEl) return;
        const dist = activeFloat - i;
        let opacity = 1;
        if (Math.abs(dist) < 0.5) opacity = 0;
        else if (dist > 0.5) opacity = Math.max(0, 1 - (dist - 0.5) * 0.4);
        else if (dist < -5) opacity = 0;
        numEl.style.opacity = opacity;
        tickEl.style.opacity = 1;
        itemEl.style.opacity = opacity;
        numEl.style.transform = `rotate(${-(i * CIR_ANGLE_STEP) - currentRotation - mobileOffset}deg)`;
      });

      if (arcRef.current) {
        const progress = Math.max(0, Math.min(arcFloat, CIR_N)) / 12;
        const circ = 2 * Math.PI * 333;
        arcRef.current.style.strokeDashoffset = circ - progress * circ;
      }

      if (activeIndex !== activeStageRef.current) {
        activeStageRef.current = activeIndex;
        setActiveIdx(activeIndex);
      }
      raf = requestAnimationFrame(update);
    };

    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const currentStage = cirStages[activeIdx];
  const numStr = (activeIdx + 1).toString().padStart(2, "0");
  const cardsData = currentStage.steps;
  const stepImages = [finalStep1, finalStep2, finalStep3];

  const scrollCards = (direction) => {
    if (cardsContainerRef.current) {
      const scrollAmount = cardsContainerRef.current.offsetWidth;
      cardsContainerRef.current.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <div className="cir-hiw-outer" ref={sectionRef} style={{ height: `${cirStages.length * 110}vh` }}>
      <div className="cir-hiw-header-wrap">
        <div className="cir-hiw-tag"><span className="cir-hiw-dot"></span>HOW IT WORKS</div>
        <h2 className="cir-hiw-title">True 360° Execution Cycle</h2>
        <p className="cir-hiw-subtitle">A 12-stage integrated execution model powered by TrueTrack™, TrueCare™ &amp; TrueCom™.</p>
      </div>

      <div className="cir-hiw-sticky">
        <div className="cir-hiw-split">
          <div className="cir-hiw-left">
            <div className="cir-hiw-mobile-header">
              <div className="cir-hiw-tag"><span className="cir-hiw-dot"></span>HOW IT WORKS</div>
              <h2 className="cir-hiw-title">True 360° Execution —<br />Zero-Stress, End-to-End Solar</h2>
              <p className="cir-hiw-subtitle">A transparent, predictable, 12-stage execution framework for every C&I rooftop solar project.</p>
            </div>

            <div className="cir-hiw-dial-wrapper">
              <div className="cir-hiw-dial-container" ref={dialRef}>
                <div className="cir-hiw-dial-bg"></div>
                <div className="cir-hiw-dial-inner-orange"></div>
                {Array.from({ length: CIR_MINOR_TICKS }).map((_, i) => (
                  <div key={`tick-${i}`} className="cir-hiw-dial-tick-min"
                    style={{ transform: `rotate(${i * (360 / CIR_MINOR_TICKS)}deg) translate(${CIR_RADIUS}px)` }} />
                ))}
                <svg style={{ position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"678px", height:"678px", pointerEvents:"none", zIndex:2 }}>
                  <circle ref={arcRef} cx="339" cy="339" r="333" fill="none" stroke="#F05A28" strokeWidth="6"
                    strokeDasharray={2 * Math.PI * 333} strokeDashoffset={2 * Math.PI * 333} strokeLinecap="round" />
                </svg>
                {cirStages.map((stage, i) => {
                  const itemAngle = i * CIR_ANGLE_STEP;
                  const isActive = i === activeIdx;
                  const isPast = i < activeIdx;
                  return (
                    <React.Fragment key={stage.id}>
                      <div className={`cir-hiw-dial-tick-maj ${isActive ? "active" : ""} ${isPast ? "past" : ""}`}
                        ref={(el) => (tickRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(${CIR_RADIUS}px)` }} />
                      <div className={`cir-hiw-dial-item ${isPast ? "past" : ""}`}
                        ref={(el) => (itemRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(${CIR_RADIUS + 40}px)` }}>
                        <div className="cir-hiw-dial-num" ref={(el) => (numRefs.current[i] = el)} style={{ transform: "rotate(-90deg)" }}>
                          {(i + 1).toString().padStart(2, "0")}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
              <div className="cir-hiw-dial-inner">
                <img src={trueRenewablesLogo} alt="True Renewables" className="cir-hiw-center-logo" ref={logoRef} loading="lazy" />
                <div className="cir-hiw-dial-pointer"></div>
              </div>
              <div className="cir-hiw-active-overlay">
                <div className="cir-hiw-inner-faint-line"></div>
                <div className="cir-hiw-active-thick-line"></div>
                <div className="cir-hiw-active-dot"></div>
                <div className="cir-hiw-active-text-block">
                  <span className="cir-hiw-active-num">{numStr}</span>
                  <span className="cir-hiw-active-title">{currentStage.title}</span>
                </div>
              </div>
            </div>

            <div className="cir-hiw-mobile-info">
              <div className="cir-hiw-mobile-stage">STAGE {activeIdx + 1}</div>
              <h3 className="cir-hiw-mobile-title">{currentStage.title}</h3>
              <p className="cir-hiw-mobile-desc">{currentStage.steps.map((s) => s.title).join(", ")}</p>
              <button className="cir-hiw-mobile-view-btn" onClick={() => setIsMobilePopupOpen(true)}>VIEW DETAILS ↗</button>
            </div>
          </div>

          <div className={`cir-hiw-right ${isMobilePopupOpen ? "mobile-open" : ""}`}>
            <div className="cir-hiw-popup-bg" onClick={() => setIsMobilePopupOpen(false)}></div>
            <div className="cir-hiw-popup-inner">
              <button className="cir-hiw-popup-close" onClick={() => setIsMobilePopupOpen(false)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              <div className="cir-hiw-stage-badge">STAGE {numStr}</div>
              <h2 className="cir-hiw-right-title">{currentStage.title}</h2>
              <div className="cir-hiw-cards-container" ref={cardsContainerRef}>
                {cardsData.map((step, idx) => (
                  <div key={idx} className="cir-hiw-step-card">
                    <div className="cir-hiw-step-img-wrap">
                      <img src={step.image} alt={step.title} className="cir-hiw-step-img" loading="lazy" />
                    </div>
                    <div className="cir-hiw-step-text">
                      <p className="cir-hiw-step-num">STEP {idx + 1}</p>
                      <h4 className="cir-hiw-step-title">{step.title}</h4>
                      {step.bullets && (
                        <ul className="cir-hiw-step-bullets">
                          {step.bullets.map((bullet, i) => (
                            <li key={i} className="cir-hiw-step-bullet">{bullet}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="cir-hiw-nav-arrows">
                <button type="button" className="cir-hiw-nav-arrow" onClick={() => scrollCards("left")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                </button>
                <button type="button" className="cir-hiw-nav-arrow" onClick={() => scrollCards("right")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                </button>
              </div>
              <div className="cir-hiw-popup-mobile-info">
                <div className="cir-hiw-mobile-stage">STAGE {activeIdx + 1}</div>
                <h3 className="cir-hiw-mobile-title">{currentStage.title}</h3>
                <p className="cir-hiw-mobile-desc">{currentStage.steps.map((s) => s.title).join(", ")}</p>
                <button className="cir-hiw-mobile-view-btn popup-btn" onClick={() => setIsMobilePopupOpen(false)}>VIEW DETAILS ↗</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ================================================
   SECTION 5 — WHY CHOOSE US
   ================================================ */
const CommercialRooftopWhyChooseUs = () => {
  const leftCards = [
    {
      num: "01",
      text: "Strong rooftop EPC capability across industrial & commercial sectors.",
    },
    {
      num: "02",
      text: "Advanced engineering expertise with top-tier design & safety standards.",
    },
    {
      num: "03",
      text: "Fully integrated digital ecosystem (TrueTrack™, TrueCare™, TrueCom™).",
    },
  ];
  const rightCards = [
    {
      num: "04",
      text: "Transparent execution, real-time visibility, zero hidden steps.",
    },
    {
      num: "05",
      text: "Tier-I global partnerships with strong DISCOM and regulatory liaison expertise.",
    },
    {
      num: "06",
      text: "25-year lifecycle management with precise monitoring.",
    },
  ];

  return (
    <section className="cir-why">
      <div className="cir-why-header">
        <p className="cir-why-tag">
          <span className="cir-why-dot" />
          WHY CHOOSE US
        </p>
        <h2 className="cir-why-title">
          Proven C&I Execution.
          <br />
          Engineered For Scale.
        </h2>
      </div>

      <div className="cir-why-body">
        <div className="cir-why-col">
          {leftCards.map((c) => (
            <div className="cir-why-card" key={c.num}>
              <p className="cir-why-num">{c.num}</p>
              <p className="cir-why-text">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="cir-why-img-wrap">
          <img src={cirWhyImg} alt="Why Choose Us" className="cir-why-img" loading="lazy" />
        </div>

        <div className="cir-why-col">
          {rightCards.map((c) => (
            <div className="cir-why-card" key={c.num}>
              <p className="cir-why-num">{c.num}</p>
              <p className="cir-why-text">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 6 — FEATURED PROJECTS
   ================================================ */
const CommercialRooftopFeaturedProjects = () => {
  const projects = [
    {
      img: cirProj1,
      title: "Large-Scale Rooftop Solar – Gujarat",
      desc: "Engineered for a high-load textile facility, this rooftop system reduced electricity costs by over 45% while ensuring uninterrupted daytime operations.",
      tags: ["GUJARAT", "2.8 MW", "TEXTILE INDUSTRY"],
    },
    {
      img: cirProj2,
      title: "Industrial Carport Solar – Automotive Facility, Maharashtra",
      desc: "Designed to maximize unused parking infrastructure, this installation generates clean power while providing shaded vehicle space for employees.",
      tags: ["MAHARASHTRA", "AUTOMOTIVE", "2.8 MW"],
    },
  ];

  return (
    <section className="cir-projects">
      <div className="cir-projects-header">
        <p className="cir-projects-tag">
          <span className="cir-projects-dot" />
          FEATURED PROJECTS
        </p>
        <h2 className="cir-projects-title">
          Commercial & Industrial Solar In Action
        </h2>
      </div>

      <div className="cir-projects-grid">
        {projects.map((p, i) => (
          <div className="cir-projects-card" key={i}>
            <div className="cir-projects-img-wrap">
              <img src={p.img} alt={p.title} className="cir-projects-card-img" loading="lazy" />
            </div>
            <div className="cir-projects-card-body">
              <h3 className="cir-projects-card-title">{p.title}</h3>
              <p className="cir-projects-card-desc">{p.desc}</p>
              <div className="cir-projects-tags">
                {p.tags.map((tag, j) => (
                  <span className="cir-projects-tag-pill" key={j}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
// /* ================================================
//    SECTION 7 — TESTIMONIALS
//    ================================================ */
// const CommercialRooftopTestimonials = () => {
//   const testimonials = [
//     {
//       id: 1,
//       name: "Anjali Verma",
//       role: "Property Owner, Bengaluru",
//       quote: '"True Renewables made our solar installation simple and hassle-free. The team was professional throughout the process."',
//       photo: Testi1,
//     },
//     {
//       id: 2,
//       name: "Sandeep Reddy",
//       role: "Managing Director, Reddy Commercial Spaces",
//       quote: '"The installation was smooth and the system is performing very well. A reliable team to work with."',
//       photo: Testi2,
//     },
//     {
//       id: 3,
//       name: "Harshvardhan Kulkarni",
//       role: "Director, Altura Industrial Solutions",
//       quote: '"True Renewables delivered a dependable solar solution for our facility and helped reduce our energy costs."',
//       photo: Testi3,
//     },
//   ];

//   const ChevronLeft = () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
//       stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="15 18 9 12 15 6" />
//     </svg>
//   );

//   const ChevronRight = () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
//       stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="9 18 15 12 9 6" />
//     </svg>
//   );

//   const [current, setCurrent] = useState(0);
//   const [slideDir, setSlideDir] = useState("");
//   const [animKey, setAnimKey] = useState(0);
//   const total = testimonials.length;

//   const prev = () => { setSlideDir("cir-testi-slide-left");  setAnimKey((k) => k + 1); setCurrent((c) => (c - 1 + total) % total); };
//   const next = () => { setSlideDir("cir-testi-slide-right"); setAnimKey((k) => k + 1); setCurrent((c) => (c + 1) % total); };

//   const TestimonialCard = ({ item, animClass }) => (
//     <div className={`cir-testi-card ${animClass || ""}`}>
//       <div className="cir-testi-card-content">
//         <div className="cir-testi-person">
//           <div>
//             <p className="cir-testi-name">{item.name}</p>
//             <p className="cir-testi-role">{item.role}</p>
//           </div>
//         </div>
//         <hr className="cir-testi-divider" />
//         <p className="cir-testi-quote">{item.quote}</p>
//       </div>
//       <div className="cir-testi-card-photo">
//         {item.photo
//           ? <img src={item.photo} alt={item.name} className="cir-testi-photo" />
//           : <div className="cir-testi-photo-placeholder" />}
//       </div>
//     </div>
//   );

//   return (
//     <section className="cir-testi-section">
//       <div className="cir-testi-header">
//         <div className="cir-testi-header-left">
//           <p className="cir-testi-tag"><span className="cir-testi-dot"></span> TESTIMONIALS</p>
//           <h2 className="cir-testi-title">Trusted By Clients Across<br />Industries</h2>
//         </div>
//         <div className="cir-testi-header-right">
//           <p className="cir-testi-subtitle">
//             Real experiences from clients who trust us<br />with their solar journey.
//           </p>
//           <div className="cir-testi-arrows">
//             <button className="cir-testi-arrow" onClick={prev} aria-label="Previous"><ChevronLeft /></button>
//             <button className="cir-testi-arrow" onClick={next} aria-label="Next"><ChevronRight /></button>
//           </div>
//         </div>
//       </div>

//       <div className="cir-testi-cards" key={animKey}>
//         <TestimonialCard item={testimonials[current % total]}       animClass={slideDir} />
//         <TestimonialCard item={testimonials[(current + 1) % total]} animClass={`${slideDir} cir-testi-delay`} />
//       </div>
//     </section>
//   );
// };
/* ================================================
   COMMERCIAL & INDUSTRIAL ROOFTOP PAGE
   ================================================ */
const CommercialRooftop = () => {
  useEffect(() => {
    document.body.classList.add("commercial-page");
    return () => {
      document.body.classList.remove("commercial-page");
    };
  }, []);

  return (
    <>
      <CommercialRooftopHero />
      <CommercialRooftopSPV />
      <CommercialRooftopWhoItsFor />
      <CommercialRooftopSolutions />
      <CommercialRooftopBenefits />
      <CommercialRooftopHowItWorks />
      <CommercialRooftopWhyChooseUs />
      <CommercialRooftopFeaturedProjects />
      {/* <CommercialRooftopTestimonials /> */}
    </>
  );
};

export default CommercialRooftop;
